import { BreadcrumbModel } from './types';

export function addColorBreadcrumbs(items: BreadcrumbModel[], name: string) {
  const rest = [
    {
      anchor: 'Colors',
      link: '/colors/',
    },
    {
      anchor: 'Color Meanings',
      link: '/colors/color-meanings/',
    },
    {
      anchor: name,
    },
  ];

  return items.concat(rest);
}
